export const bulletinBoardDetails = [
  {
    text: 'This is the first bulletin with important updates about our latest project',
    link: 'https://example.com/bulletin1', // Replace with the actual link to the bulletin
    status: 'new',
  },
  {
    text: 'Don’t miss our upcoming event! Check out the details and register today',
    link: 'https://example.com/bulletin2', // Replace with the actual link to the bulletin
    status: 'new',
  },
  {
    text: 'Here’s a summary of last month’s achievements and milestones',
    link: 'https://example.com/bulletin3', // Replace with the actual link to the bulletin
    status: 'old',
  },
  {
    text: 'We have updated our policies. Please review the changes to stay informed',
    link: 'https://example.com/bulletin4', // Replace with the actual link to the bulletin
    status: 'old',
  },
];
